module.exports = __webpack_public_path__ + "img/5eef8ff.jpg";